export function hasDuplicateLicenseTypes(types: Array<string | null>): boolean {
  const selectedTypes = types.filter((type): type is string => type !== null);
  return new Set(selectedTypes).size !== selectedTypes.length;
}

export function isNonNegativeInteger(value: unknown): boolean {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0;
}
